import React from 'react';
import SearchForm from '../components/SearchForm';

export default function HeroSection() {
  return (
    <div className="relative min-h-screen bg-[#080c1a] text-white overflow-hidden flex flex-col justify-center">

      {/* Background gradient blobs — clamped so they never cause horizontal scroll */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-[-10%] left-[-5%] w-64 h-64 sm:w-96 sm:h-96 lg:w-[500px] lg:h-[500px] bg-violet-700 opacity-20 rounded-full blur-[80px] sm:blur-[120px]" />
        <div className="absolute bottom-[-5%] right-[-5%] w-48 h-48 sm:w-72 sm:h-72 lg:w-[400px] lg:h-[400px] bg-indigo-600 opacity-20 rounded-full blur-[60px] sm:blur-[100px]" />
        <div className="absolute top-[40%] left-[45%] w-32 h-32 sm:w-48 sm:h-48 lg:w-[250px] lg:h-[250px] bg-orange-500 opacity-10 rounded-full blur-[50px] sm:blur-[80px]" />
        <div className="absolute inset-0 opacity-[0.04]"
          style={{ backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(to right, #ffffff 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-20 lg:py-24 w-full">

        {/* Badge */}
        <div className="flex justify-center mb-6 sm:mb-8">
          <span className="inline-flex items-center gap-2 bg-white/5 border border-white/10 backdrop-blur-sm text-orange-300 text-xs font-semibold px-3 sm:px-4 py-2 rounded-full tracking-wider uppercase">
            <span className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" />
            Trusted by 2M+ Travelers Worldwide
          </span>
        </div>

        {/* Headline */}
        <div className="text-center mb-8 sm:mb-12">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black leading-[1.05] tracking-tight mb-4 sm:mb-6">
            Book Flights
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-pink-400 to-violet-400">
              in One Click
            </span>
          </h1>
          <p className="text-slate-400 text-base sm:text-lg md:text-xl max-w-2xl mx-auto leading-relaxed px-2">
            Compare hundreds of fares across all major airlines instantly.
            No hidden fees. No surprises. Just your best price.
          </p>
        </div>

        {/* Search Form */}
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl sm:rounded-3xl p-4 sm:p-6 md:p-8 shadow-2xl max-w-5xl mx-auto">
          <SearchForm />
        </div>

        {/* Stats */}
        <div className="mt-8 sm:mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-8 md:gap-16 max-w-xl sm:max-w-none mx-auto">
          {[
            { value: '500+', label: 'Routes Covered' },
            { value: '8',    label: 'Airline Partners' },
            { value: '24/7', label: 'Live Support' },
            { value: '$0',   label: 'Booking Fees' },
          ].map(stat => (
            <div key={stat.label} className="text-center">
              <p className="text-2xl sm:text-3xl font-black text-white">{stat.value}</p>
              <p className="text-slate-500 text-xs sm:text-sm mt-0.5">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 sm:h-32 bg-gradient-to-t from-white to-transparent pointer-events-none" />
    </div>
  );
}
